import { render, staticRenderFns } from "./EditReglement.vue?vue&type=template&id=5d2c19d6"
import script from "./EditReglement.vue?vue&type=script&lang=js"
export * from "./EditReglement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports